import type {ReactNode, FunctionComponent, VoidFunctionComponent} from 'react';
import classNames from 'classnames';

import {Spinner} from '../../../atoms/spinner';
import {Heading, HeadingLevel} from '../../../atoms/heading';
import {NoConnectionIllustration} from '../../../illustrations';
import {TypographySize, useTypography} from '../../../hooks/typography';

import type {Props} from './types';
import styles from './styles.module.css';

const Wrapper: FunctionComponent<{ children: ReactNode }> = (props) => (
    <div className={styles.outerWrapper}>
        <div className={styles.innerWrapper}>{props.children}</div>
    </div>
);

const Body: FunctionComponent<{ children: ReactNode }> = (props) => {
    const bodyClassName = useTypography({
        size: TypographySize.BodyXL,
    });

    return <p className={classNames(bodyClassName, styles.body)}>{props.children}</p>;
};

export const NoConnectionBlock: VoidFunctionComponent<Props> = (props) => {
    const {establishingConnection} = props;

    if (establishingConnection) {
        return (
            <Wrapper>
                <Heading className={styles.heading} level={HeadingLevel.FIRST} size={700}>
                    <Spinner />
                    <span className={styles.afterSpinnerText}>Подключаемся...</span>
                </Heading>
                <Body>Восстанавливаем соединение к серверу</Body>
            </Wrapper>
        );
    }

    return (
        <Wrapper>
            <div className={styles.illustration}>
                <NoConnectionIllustration />
            </div>
            <Heading className={styles.heading} level={HeadingLevel.FIRST} size={700}>
                Нет подключения
            </Heading>
            <Body>Чтобы оставаться на связи, подключитесь к сети</Body>
        </Wrapper>
    );
};
